const gtag = (...args) => window.gtag?.(...args);

const analytics = {
  // Page / session
  pageView: (path) => gtag('event', 'page_view', { page_path: path }),

  // Section visibility
  sectionView: (section) => gtag('event', 'section_view', {
    event_category: 'Engagement',
    event_label: section,
  }),

  // Language switch
  languageSwitch: (lang) => {
    gtag('event', 'language_switch', {
      event_category: 'Engagement',
      event_label: lang,
    });
    gtag('set', 'user_properties', { site_language: lang });
  },

  // Booking platform click
  bookingClick: (platform) => gtag('event', 'booking_click', {
    event_category: 'Booking',
    event_label: platform,
  }),

  // Booking confirmed — fired when easybooking iframe posts conversion message
  bookingConfirmed: (conversionType = 'reservation', amount = 0) => gtag('event', 'purchase', {
    event_category: 'Booking',
    event_label: conversionType,
    transaction_id: `eb_${Date.now()}`,
    value: amount,
    currency: 'CHF',
  }),

  // Gallery room opened
  galleryOpen: (room) => gtag('event', 'gallery_open', {
    event_category: 'Gallery',
    event_label: room,
  }),

  // FAQ tab switch
  faqTabSwitch: (tab) => gtag('event', 'faq_tab_switch', {
    event_category: 'FAQ',
    event_label: tab,
  }),

  // FAQ individual question opened
  faqQuestionOpen: (question) => gtag('event', 'faq_question_open', {
    event_category: 'FAQ',
    event_label: question,
  }),

  // CTA clicks (hero, about, nav)
  ctaClick: (label) => gtag('event', 'cta_click', {
    event_category: 'CTA',
    event_label: label,
  }),

  // Season toggle in activities
  seasonToggle: (season) => gtag('event', 'season_toggle', {
    event_category: 'Activities',
    event_label: season,
  }),

  // Outbound link clicks (footer, external)
  outboundClick: (url, label) => gtag('event', 'outbound_click', {
    event_category: 'Outbound',
    event_label: label || url,
    link_url: url,
    transport_type: 'beacon',
  }),

  // Navigation click
  navClick: (section) => gtag('event', 'nav_click', {
    event_category: 'Navigation',
    event_label: section,
  }),

  // Scroll depth tracking — call once from App.js
  initScrollDepth: () => {
    const thresholds = [25, 50, 75, 100];
    const fired = new Set();
    const onScroll = () => {
      const scrollPct = Math.round(
        (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
      );
      thresholds.forEach((t) => {
        if (scrollPct >= t && !fired.has(t)) {
          fired.add(t);
          gtag('event', 'scroll_depth', {
            event_category: 'Engagement',
            event_label: `${t}%`,
            value: t,
          });
        }
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  },

  // Engagement time — fires on page unload with time spent
  initEngagementTime: () => {
    const start = Date.now();
    const onUnload = () => {
      const seconds = Math.round((Date.now() - start) / 1000);
      gtag('event', 'engagement_time', {
        event_category: 'Engagement',
        event_label: `${seconds}s`,
        value: seconds,
        transport_type: 'beacon',
      });
    };
    window.addEventListener('beforeunload', onUnload);
    return () => window.removeEventListener('beforeunload', onUnload);
  },
};

export default analytics;
